import {RepositoryFactory} from '@/app/repositories/repository-factory.js';
// import Repository from '@/app/repositories/repository'

const uomRepository = RepositoryFactory.get('uom');

export default Object.assign(uomRepository, {
    // addOrder : function(items){
    //     return Repository.post(`/order/createOrder`, items);
    // }
});
